import { required } from "ra-core";
import { NumberInput } from "@/components/admin/number-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { accountTypeChoices } from "../shared/transactionModel";

export const AccountInputs = () => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    <TextInput source="name" validate={required()} helperText={false} />
    <SelectInput
      source="type"
      choices={accountTypeChoices}
      validate={required()}
      helperText={false}
    />
    <NumberInput source="initial_balance" helperText={false} />
    <TextInput source="currency" helperText={false} defaultValue="RUB" />
    <TextInput
      source="notes"
      multiline
      rows={2}
      className="md:col-span-2"
      helperText={false}
    />
  </div>
);
